import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { createInvoice } from '../../api/finance';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'https://kanguroo-crm-production.up.railway.app/api/v1';
const api = axios.create({ baseURL: API_BASE });
api.interceptors.request.use((c) => { const t = localStorage.getItem('token'); if (t) c.headers.Authorization = `Bearer ${t}`; return c; });

export default function InvoiceForm() {
  const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
  const [deals, setDeals] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ customer_id: '', deal_id: '', type: 'service', media_budget_amount: '0', currency: 'TRY', issued_date: new Date().toISOString().split('T')[0], due_date: '', notes: '' });
  const [items, setItems] = useState([{ description: '', category: 'management', quantity: '1', unit_price: '' }]);

  useEffect(() => {
    api.get('/customers/').then((r) => setCustomers(r.data)).catch(() => {});
    api.get('/deals/').then((r) => setDeals(r.data)).catch(() => {});
  }, []);

  const set = (f, v) => setForm((p) => ({ ...p, [f]: v }));
  const addItem = () => setItems((p) => [...p, { description: '', category: 'other', quantity: '1', unit_price: '' }]);
  const removeItem = (i) => setItems((p) => p.filter((_, idx) => idx !== i));
  const setItem = (i, f, v) => setItems((p) => p.map((it, idx) => idx === i ? { ...it, [f]: v } : it));

  const totalService = items.reduce((a, it) => a + (parseFloat(it.quantity) || 0) * (parseFloat(it.unit_price) || 0), 0);
  const totalMedia = parseFloat(form.media_budget_amount) || 0;
  const grandTotal = totalService + totalMedia;

  const handleSubmit = async () => {
    if (!form.customer_id) return alert('Müşteri seçiniz');
    if (items.some((it) => !it.description || !it.unit_price)) return alert('Tüm kalemleri doldurunuz');
    setLoading(true);
    try {
      await createInvoice({ ...form, service_amount: totalService.toFixed(2), media_budget_amount: totalMedia.toFixed(2), deal_id: form.deal_id || null, items: items.map((it) => ({ ...it, quantity: parseFloat(it.quantity), unit_price: parseFloat(it.unit_price) })) });
      alert('Fatura oluşturuldu');
      navigate('/finance/invoices');
    } catch (e) { alert(e?.response?.data?.detail || 'Hata'); } finally { setLoading(false); }
  };

  return (
    <div className="p-6 max-w-3xl mx-auto space-y-6">
      <div className="flex items-center gap-3">
        <button onClick={() => navigate(-1)} className="text-gray-400 hover:text-gray-700 text-xl">←</button>
        <h1 className="text-2xl font-bold text-gray-900">Yeni Fatura</h1>
      </div>
      <div className="bg-white border border-gray-200 rounded-xl p-5 space-y-4">
        <h2 className="font-semibold text-gray-700">Fatura Bilgileri</h2>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">Müşteri *</label>
            <select value={form.customer_id} onChange={(e) => set('customer_id', e.target.value)} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
              <option value="">Müşteri seçin</option>
              {customers.map((c) => <option key={c.id} value={c.id}>{c.company_name || c.full_name}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">Deal (opsiyonel)</label>
            <select value={form.deal_id} onChange={(e) => set('deal_id', e.target.value)} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
              <option value="">Deal seçin</option>
              {deals.map((d) => <option key={d.id} value={d.id}>{d.title}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">Tür</label>
            <select value={form.type} onChange={(e) => set('type', e.target.value)} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
              <option value="service">Hizmet</option>
              <option value="media_budget">Medya Bütçesi</option>
              <option value="mixed">Karma</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">Para Birimi</label>
            <select value={form.currency} onChange={(e) => set('currency', e.target.value)} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
              <option value="TRY">TRY</option><option value="USD">USD</option><option value="EUR">EUR</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">Fatura Tarihi</label>
            <input type="date" value={form.issued_date} onChange={(e) => set('issued_date', e.target.value)} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">Vade Tarihi</label>
            <input type="date" value={form.due_date} onChange={(e) => set('due_date', e.target.value)} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
          </div>
        </div>
        {(form.type === 'media_budget' || form.type === 'mixed') && (
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">Medya Bütçesi</label>
            <input type="number" value={form.media_budget_amount} onChange={(e) => set('media_budget_amount', e.target.value)} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="0.00" />
          </div>
        )}
        <div>
          <label className="block text-sm font-medium text-gray-600 mb-1">Notlar</label>
          <textarea value={form.notes} onChange={(e) => set('notes', e.target.value)} rows={2} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
        </div>
      </div>

      <div className="bg-white border border-gray-200 rounded-xl p-5 space-y-4">
        <div className="flex items-center justify-between">
          <h2 className="font-semibold text-gray-700">Kalemler</h2>
          <button onClick={addItem} className="text-sm text-blue-600 hover:underline">+ Ekle</button>
        </div>
        {items.map((item, i) => (
          <div key={i} className="grid grid-cols-12 gap-2 items-end">
            <div className="col-span-5">
              {i === 0 && <label className="block text-xs text-gray-500 mb-1">Açıklama</label>}
              <input type="text" value={item.description} onChange={(e) => setItem(i, 'description', e.target.value)} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Hizmet açıklaması" />
            </div>
            <div className="col-span-2">
              {i === 0 && <label className="block text-xs text-gray-500 mb-1">Kategori</label>}
              <select value={item.category} onChange={(e) => setItem(i, 'category', e.target.value)} className="w-full border border-gray-300 rounded-lg px-2 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
                <option value="management">Yönetim</option><option value="content">İçerik</option><option value="ads">Reklam</option><option value="consulting">Danışmanlık</option><option value="other">Diğer</option>
              </select>
            </div>
            <div className="col-span-1">
              {i === 0 && <label className="block text-xs text-gray-500 mb-1">Adet</label>}
              <input type="number" value={item.quantity} onChange={(e) => setItem(i, 'quantity', e.target.value)} className="w-full border border-gray-300 rounded-lg px-2 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
            </div>
            <div className="col-span-2">
              {i === 0 && <label className="block text-xs text-gray-500 mb-1">Birim Fiyat</label>}
              <input type="number" value={item.unit_price} onChange={(e) => setItem(i, 'unit_price', e.target.value)} className="w-full border border-gray-300 rounded-lg px-2 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="0.00" />
            </div>
            <div className="col-span-1 text-right">
              {i === 0 && <label className="block text-xs text-gray-500 mb-1">Toplam</label>}
              <span className="text-sm font-medium text-gray-700 py-2 block">{((parseFloat(item.quantity)||0)*(parseFloat(item.unit_price)||0)).toLocaleString('tr-TR')}</span>
            </div>
            <div className="col-span-1 text-center">
              {items.length > 1 && <button onClick={() => removeItem(i)} className="text-red-400 hover:text-red-600 text-lg">x</button>}
            </div>
          </div>
        ))}
        <div className="border-t border-gray-100 pt-4 space-y-1 text-sm">
          <div className="flex justify-between text-gray-600"><span>Hizmet Toplamı</span><span className="font-medium">{totalService.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} {form.currency}</span></div>
          {totalMedia > 0 && <div className="flex justify-between text-gray-500"><span>Medya Bütçesi</span><span>{totalMedia.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} {form.currency}</span></div>}
          <div className="flex justify-between text-gray-900 font-bold text-base border-t pt-1"><span>Genel Toplam</span><span>{grandTotal.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} {form.currency}</span></div>
        </div>
      </div>

      <div className="flex gap-3 justify-end">
        <button onClick={() => navigate(-1)} className="px-4 py-2 border border-gray-300 rounded-lg text-sm text-gray-600 hover:bg-gray-50 transition">İptal</button>
        <button onClick={handleSubmit} disabled={loading} className="px-6 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 disabled:opacity-50 transition">{loading ? 'Kaydediliyor...' : 'Fatura Oluştur'}</button>
      </div>
    </div>
  );
}
